import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrTimeApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    timeDashboard(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrTimeDashboard>> {
        return this.http.get<APIResponseWrapper<HrModels.HrTimeDashboard>>(`${this.baseUrl}/time/dashboard`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    attendanceEvents(owningCompanyId?: number, employeeId?: number, from?: string, to?: string, limit?: number): Observable<APIResponseWrapper<HrModels.HrAttendanceEvent[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrAttendanceEvent[]>>(`${this.baseUrl}/time/attendance-events`, {
          params: this.params({ owningCompanyId, employeeId, from, to, limit })
        });
      }
    
    recordAttendanceEvent(request: HrModels.HrAttendanceEvent): Observable<APIResponseWrapper<HrModels.HrAttendanceEvent>> {
        return this.http.post<APIResponseWrapper<HrModels.HrAttendanceEvent>>(`${this.baseUrl}/time/attendance-events`, request);
      }
    
    timesheets(owningCompanyId?: number, status?: string, periodStart?: string, periodEnd?: string, employeeId?: number, limit?: number): Observable<APIResponseWrapper<HrModels.HrTimesheet[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrTimesheet[]>>(`${this.baseUrl}/time/timesheets`, {
          params: this.params({ owningCompanyId, status, periodStart, periodEnd, employeeId, limit })
        });
      }
    
    generateTimesheets(request: HrModels.HrTimesheetGenerationRequest): Observable<APIResponseWrapper<HrModels.HrTimesheet[]>> {
        return this.http.post<APIResponseWrapper<HrModels.HrTimesheet[]>>(`${this.baseUrl}/time/timesheets/generate`, request);
      }
    
    submitTimesheet(timesheetId: number, request: HrModels.HrTimesheetDecisionRequest = {}): Observable<APIResponseWrapper<HrModels.HrTimesheet>> {
        return this.http.post<APIResponseWrapper<HrModels.HrTimesheet>>(`${this.baseUrl}/time/timesheets/${timesheetId}/submit`, request);
      }
    
    approveTimesheet(timesheetId: number, request: HrModels.HrTimesheetDecisionRequest = {}): Observable<APIResponseWrapper<HrModels.HrTimesheet>> {
        return this.http.post<APIResponseWrapper<HrModels.HrTimesheet>>(`${this.baseUrl}/time/timesheets/${timesheetId}/approve`, request);
      }
    
    lockTimesheet(timesheetId: number, request: HrModels.HrTimesheetDecisionRequest = {}): Observable<APIResponseWrapper<HrModels.HrTimesheet>> {
        return this.http.post<APIResponseWrapper<HrModels.HrTimesheet>>(`${this.baseUrl}/time/timesheets/${timesheetId}/lock`, request);
      }
    
    attendanceExceptions(owningCompanyId?: number, status?: string, employeeId?: number, limit?: number): Observable<APIResponseWrapper<HrModels.HrAttendanceException[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrAttendanceException[]>>(`${this.baseUrl}/time/exceptions`, {
          params: this.params({ owningCompanyId, status, employeeId, limit })
        });
      }
    
    resolveAttendanceException(exceptionId: number, reason?: string): Observable<APIResponseWrapper<HrModels.HrAttendanceException>> {
        return this.http.post<APIResponseWrapper<HrModels.HrAttendanceException>>(`${this.baseUrl}/time/exceptions/${exceptionId}/resolve`, { reason });
      }
    
    requestTimeAdjustment(request: HrModels.HrTimeAdjustmentRequest): Observable<APIResponseWrapper<HrModels.HrTimeAdjustmentRequest>> {
        return this.http.post<APIResponseWrapper<HrModels.HrTimeAdjustmentRequest>>(`${this.baseUrl}/time/adjustments`, request);
      }
    
    timeAdjustments(owningCompanyId?: number, status?: string, employeeId?: number, limit?: number): Observable<APIResponseWrapper<HrModels.HrTimeAdjustmentRequest[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrTimeAdjustmentRequest[]>>(`${this.baseUrl}/time/adjustments`, {
          params: this.params({ owningCompanyId, status, employeeId, limit })
        });
      }
    
    approveTimeAdjustment(adjustmentId: number, reason?: string): Observable<APIResponseWrapper<HrModels.HrTimeAdjustmentRequest>> {
        return this.http.post<APIResponseWrapper<HrModels.HrTimeAdjustmentRequest>>(`${this.baseUrl}/time/adjustments/${adjustmentId}/approve`, { reason });
      }
    
    rejectTimeAdjustment(adjustmentId: number, reason?: string): Observable<APIResponseWrapper<HrModels.HrTimeAdjustmentRequest>> {
        return this.http.post<APIResponseWrapper<HrModels.HrTimeAdjustmentRequest>>(`${this.baseUrl}/time/adjustments/${adjustmentId}/reject`, { reason });
      }
  };
}

